
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import ReconnectionCustomer from "../components/reconnectionCustomer";
import Footer from "../components/footer";

function ReconnectionCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      < ReconnectionCustomer /> 
    <Footer />
    </div>
  </div>
  // <Login/>
  );
}
export default ReconnectionCustomerPage;
